import React from 'react';
import { Home } from './home/Home';

export const App: React.FC = (): JSX.Element => (
    <div className="App">
        <Home />
    </div>
);
